import { api } from '@services';

import FieldConfiguration, {
  FieldConfigurationLocationOptions,
  IFieldConfiguration,
  IFieldConfigurationApiModel,
} from '@models/FieldConfiguration.model';

interface IFieldOrder {
  fieldName?: string;
  customFieldId?: string;
  order: number;
}
interface INewFieldConfiguration {
  updatedOrders: IFieldOrder[];
}
interface IPatchProductVariables {
  location: FieldConfigurationLocationOptions;
  data: INewFieldConfiguration;
}
const updateOrderFieldConfiguration = async ({
  location,
  data,
}: IPatchProductVariables): Promise<IFieldConfiguration[]> => {
  const { data: fieldsConfiguration } = await api.put<
    IFieldConfigurationApiModel[]
  >(`/fieldsConfiguration/updateOrders/${location}`, data);
  if (fieldsConfiguration.length > 0)
    return FieldConfiguration.arrayFromApiModel(fieldsConfiguration, location);
  return FieldConfiguration.defaultArray(location);
};

export { updateOrderFieldConfiguration };
